import { GithubFilled } from '@ant-design/icons';
import styled from 'types/theme.types';
import type { FC } from 'react';

type GithubLogoProps = {
  style?: React.CSSProperties;
  className?: string;
};

const GithubLogo: FC<GithubLogoProps> = props => <StyledGithubFilled {...props} />;

const StyledGithubFilled = styled(GithubFilled)`
  color: var(--text-tint-gray-hover);
  font-size: 24px;
`;

export default GithubLogo;
